import { ButtonIcon, setColorTheme } from '@facephi/ui-react';
import styled from 'styled-components';

export const ProhibitButtonIcon = styled(ButtonIcon)`
  color: ${setColorTheme('error400')};
`;
